import { reject, resolve } from 'core-js/fn/promise'
import axios from '../../axios.js'

function parsePayload(payload, type, status) {
  let search = []
  if (payload['s']) {
    search = payload['s']['$and'] ? payload['s']['$and'] : {}
  } else {
    payload.s = {}
  }
  if (search) payload['s']['$and'] ? (payload['s']['$and'] = search) : {}
  payload.s.status = status
    ? status
    : payload.status
    ? payload.status
    : ['open']
  if (!payload.type) payload.s.type = type

  return payload
}
//
// function parsePayload(payload, type, status) {
//   console.log(
//     `payload ${JSON.stringify(payload)} + type ${JSON.stringify(
//       type
//     )} + status ${JSON.stringify(status)}`
//   )
//   let search = []
//   if (payload['s']) {
//     search = payload['s']['$and'] ? payload['s']['$and'] : {}
//   }
//   search = addTypeToSearch(search, payload, type, status)
//   payload['s'] = { $and: search }
//   return payload
// }
function addTypeToSearch(search, payload, type, status) {
  const recordIndex = search.findIndex((s) => s['type'] !== undefined)
  if (recordIndex >= 0) {
    search.splice(recordIndex, 1)
  }
  payload.s.status = status
    ? status
    : payload.status
    ? payload.status
    : ['open', 'close', 'paid', 'processing']
  if (!payload.type) payload.s.type = type

  return search
}
export default {
  async fetchRecords({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get('/lhdn-submissions', {
          params: payload,
        })
        .then((response) => {
          commit('SET_SUBMISSIONS', response.data)
          commit('SET_PAGINATION', {
            currentPage: response.headers['x-pagination-page'],
            totalPage: response.headers['x-pagination-page-count'],
            pageTotal: response.headers['x-pagination-count'],
            totalItem: response.headers['x-pagination-total'],
          })
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchRecord(context, uuid) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/lhdn-submissions/${uuid}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchHistory(context, uuid) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/lhdn-submissions/webhook-history/${uuid}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  generateUblPayload(context, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/lhdn-submissions/generateUblPayload`, payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
